import React from 'react'
import PropTypes from 'prop-types'

const DashboardIcon = ({ style, width = 20, height = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    width={width}
    height={height}
    viewBox="0 0 20 20"
  >
    <g fill="#FFF" fillRule="evenodd" transform="translate(3 3)">
      <rect width="7" height="9" rx=".5" />
      <rect width="7" height="4" y="10" rx=".5" />
      <rect width="6" height="5" x="8" rx=".5" />
      <rect width="6" height="8" x="8" y="6" rx=".5" />
    </g>
  </svg>
)

DashboardIcon.propTypes = {
  style: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
}

export default DashboardIcon
